import React from "react";

const ContactUs = ({ commonData, clientData }) => (
  <div
    className="contact-us p-4"
    id={
      clientData.contactUsSlug ? clientData.contactUsSlug : commonData.contactUsSlug
    }
  >
    <div className="section-title">{commonData.contactUsSectionHeading}</div>
    <div className="pad-full">
      <div
        className="contact-us-content"
        dangerouslySetInnerHTML={{
          __html:
            clientData.clientContactUsContent !== ""
              ? clientData.clientContactUsContent
              : commonData.commonContactUsContent,
        }}
      ></div>
      {clientData.clientContactUsDetails &&
      clientData.clientContactUsDetails.length !== 0 ? (
        <div className="contact-us-details">
          {clientData?.clientContactUsDetails?.map(function (contact, index) {
            return (
              <div key={index} className="contact-box">
                <div className="contact-name">{contact.contactName}</div>
                <div className="contact-email">
                  <a href={`mailto:${contact.contactEmail}`} className="purple">
                    {contact.contactEmail}
                  </a>
                </div>
                {contact.contactPhone !== "" ? (
                  <div className="contact-phone">
                    <a href={`tel:+${contact.contactPhone}`} className="purple">
                      {contact.contactPhone}
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="contact-us-details">
          {commonData?.commonContactUsDetails?.map(function (contact, index) {
            return (
              <div key={index} className="contact-box">
                <div className="contact-name">{contact.contactName}</div>
                <div className="contact-email">
                  <a href={`mailto:${contact.contactEmail}`} className="purple">
                    {contact.contactEmail}
                  </a>
                </div>
                {contact.contactPhone !== "" ? (
                  <div className="contact-phone">
                    <a href={`tel:+${contact.contactPhone}`} className="purple">
                      {contact.contactPhone}
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
);

export default ContactUs;
